import { ClaioSchemaGroup, ClaioSchemaItem } from "../../../../domain/claio";
import { IClaioSchemaGroupBean, IClaioSchemaItemBean } from "../beans";
import { ClaioSchemaImageSource } from "../ClaioSchemaImageSource";

export class ClaioSchemaInformationTranslator {
  constructor(private _getToken: () => string) {
  }

  toClaioSchemaGroups(beans: IClaioSchemaGroupBean[]): ClaioSchemaGroup[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toClaioSchemaGroup(bean));
  }

  private toClaioSchemaGroup(bean: IClaioSchemaGroupBean): ClaioSchemaGroup {
    if (!bean) { return null; }
    const group = new ClaioSchemaGroup();
    group.name = bean.name;
    group.items = bean.items.map(s => this.toClaioSchemaItem(s));
    Object.freeze(group);
    return group;
  }

  private toClaioSchemaItem(bean: IClaioSchemaItemBean): ClaioSchemaItem {
    if (!bean) { return null; }
    if (bean.templateId == null) { throw new Error("templateId is empty!!!"); }
    if (bean.groupId == null) { throw new Error("groupId is empty!!!"); }
    if (bean.itemId == null) { throw new Error("itemId is empty!!!"); }
    const info = new ClaioSchemaItem();
    info.templateId = bean.templateId;
    info.groupId = bean.groupId;
    info.itemId = bean.itemId;
    info.imageSource = new ClaioSchemaImageSource(this._getToken, bean.templateId, bean.groupId, bean.itemId);
    Object.freeze(info);
    return info;
  }
}
